<div class="content-block">
    <div class="dx-card responsive-paddings">

<div class="content-grid">
    <h2 class="content-block">Batches</h2>

    <!-- <dx-data-grid class="dx-card wide-card" [dataSource]="dataSource" [showBorders]="false" [focusedRowEnabled]="true"
        [focusedRowIndex]="0" [columnAutoWidth]="true" [columnHidingEnabled]="true">
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxi-column dataField="BatchName" caption="Batch Name"> </dxi-column>
        <dxi-column dataField="Id" caption="Batch Id"> </dxi-column>
        <dxi-column dataField="Created" caption="Date & Time"> </dxi-column>
        <dxi-column dataField="TotalAmount" caption="Total amount"> </dxi-column>
        <dxi-column dataField="NumberOfRecords" caption="Transactions"> </dxi-column>
        <dxi-column dataField="Errors" caption="Errors"> </dxi-column>
        <dxi-column dataField="Status" caption="Status"> </dxi-column>
        <dxi-column caption="Link" [cellTemplate]="'linkTemplate'"></dxi-column>
        <div *dxTemplate="let data of 'linkTemplate'">
            <a [routerLink]="['/batch-transactions']" [queryParams]="{ batchId: data.data.Id }">Details</a>
        </div>
    </dx-data-grid> -->
</div>

</div></div>